// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slides-player {
  z-index: 1;
  display: flex;
  width: 100%;
  flex-direction: column;
  left: 0;
  right: 0;
  bottom: 0;
  margin-left: auto;
  margin-right: auto;
  width: auto;
  z-index: 2;
  position: absolute;
  height: 100%;
}
.slides-player.isSlideSelected {
  background: rgba(0, 0, 0, 0.5);
}
@media (max-width: 768px) {
  .slides-player {
    margin-top: 30px;
  }
}
.slides-player .top {
  width: 100%;
  height: 65%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}
.slides-player .top .arrow {
  font-size: 2.5rem;
  cursor: pointer;
  color: white;
  transition: all 0.3s ease;
  user-select: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
}
.slides-player .top .arrow:hover {
  background-color: rgba(255, 255, 255, 0.1);
  transform: scale(1.2);
}
.slides-player .top .arrow:active {
  transform: scale(0.95);
}
.slides-player .top .preview-box {
  width: 70%;
  height: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.slides-player .top .preview-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.slides-player .center {
  height: 10%;
  padding: 0 10rem;
  text-align: center;
}
.slides-player .bottom {
  padding: 1rem;
  width: 100%;
  height: 35%;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: wrap;
  flex-direction: column;
  cursor: grab;
  user-select: none;
}
.slides-player .bottom.dragging {
  cursor: grabbing;
}
.slides-player .bottom {
  /* Scrollbar styling */
}
.slides-player .bottom::-webkit-scrollbar {
  height: 8px;
}
.slides-player .bottom::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}
.slides-player .bottom::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 10px;
}
.slides-player .bottom::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.8);
}
.slides-player .bottom .draggable-slide {
  flex: 0 0 auto;
}
.slides-player .bottom img {
  pointer-events: none;
  -webkit-user-drag: none;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/SlidesPlayer/SlidesPlayer.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;AACJ;AACI;EACI,8BAAA;AACR;AAEI;EAnBJ;IAoBQ,gBAAA;EACN;AACF;AACI;EACI,WAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AACR;AACQ;EACI,iBAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AACZ;AACY;EACI,0CAAA;EACA,qBAAA;AAChB;AAEY;EACI,sBAAA;AAAhB;AAIQ;EACI,UAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFZ;AAIY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAFhB;AAMI;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;AAJR;AAMI;EACI,aAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;AAJR;AAMQ;EACI,gBAAA;AAJZ;AAZI;EAmBI,sBAAA;AAJR;AAKQ;EACI,WAAA;AAHZ;AAMQ;EACI,oCAAA;EACA,mBAAA;AAJZ;AAOQ;EACI,oCAAA;EACA,mBAAA;AALZ;AAOY;EACI,oCAAA;AALhB;AASQ;EACI,cAAA;AAPZ;AAUQ;EACI,oBAAA;EACA,uBAAA;AARZ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
